module.exports = __webpack_public_path__ + "static/media/EGP10.7df2eacc.png";